import ActivityNoResults from "./no-results";
import calendar from "./calendar"

const modul = angular
    .module("searchActivityComponents", [])

    .directive("activityNoResults", ActivityNoResults)
    .directive("calendar", calendar);

export default modul.name;
